import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { CustomField } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class CustomFieldService {

    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) { }

    list(active?: boolean) {
        const headers = this.authService.authHeaders();
        const qs: string[] = [];
        if (active !== undefined) {
            qs.push('active=' + active.toString());
        }
        let url = '/api/scheduling/customfield/';
        if (qs.length) {
            url += '?' + qs.join('&');
        }
        return this.http.get<CustomField[]>(url, { headers }).pipe(
                switchMap(response => response)
            );
    }

    get(id: number) {
        const headers = this.authService.authHeaders();
        return this.http.get<CustomField>(
            '/api/scheduling/customfield/' + id + '/',
            { headers }
        );
    }

    create(field: CustomField) {
        const headers = this.authService.authHeaders();
        return this.http.post<CustomField>(
            '/api/scheduling/customfield/',
            field,
            { headers }
        );
    }

    update(field: CustomField) {
        const headers = this.authService.authHeaders();
        return this.http.put<CustomField>(
            '/api/scheduling/customfield/' + field.id + '/',
            field,
            { headers }
        );
    }

    activate(field: CustomField) {
        const headers = this.authService.authHeaders();
        return this.http.put<CustomField>(
            '/api/scheduling/customfield/' + field.id + '/activate/',
            null,
            { headers }
        );
    }

    deactivate(field: CustomField) {
        const headers = this.authService.authHeaders();
        return this.http.put<CustomField>(
            '/api/scheduling/customfield/' + field.id + '/deactivate/',
            null,
            { headers }
        );
    }
}
